import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../utils/Hooks";

interface DlogTableProps {
}

export const DlogTable: React.FC<DlogTableProps> = () => {

    const dlogState = useAppSelector(state => state.dlogs);

    return (
        <table className="data">
            <thead>
            <tr>
                <th style={{width: '70px'}}>Kellaaeg</th>
                <th style={{width: '50px'}}>Tüüp</th>
                <th style={{width: '100px'}}>Saaja</th>
                <th style={{width: '150px'}}>Pealkiri</th>
                <th className="w150">Sisu</th>
            </tr>
            </thead>
            <tbody>
            {dlogState.logs.map( log => (
                <tr key={log.id}>
                    <td>{log.formatted_created_at}</td>
                    <td>{log.type}</td>
                    <td>{log.recipient}<br /><small>{log.email}</small></td>
                    <td>{log.title}</td>
                    <td>{log.message}</td>
                </tr>
            ))}
            </tbody>
        </table>
    )

}